import { authServer, feedServer } from '@/http';

let timer;
export default {
    async authenticate(context, payload) {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        const urlencoded = new URLSearchParams();
        urlencoded.append("client_id", "app");
        urlencoded.append("client_secret", "scorpion");
        urlencoded.append("grant_type", "authorization_code");
        urlencoded.append("code", payload.code);
        urlencoded.append("redirect_uri", "http://localhost:8080/auth");
        urlencoded.append("scope", "openid offline_access api:read");
        urlencoded.append("code_verifier", payload.codeVerifier);
        urlencoded.append("code_challenge_method", "S256");

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: urlencoded,
            redirect: "follow",
        };

        const tokenResponse = await fetch("http://localhost:3009/token", requestOptions);
        const tokenInfo = await tokenResponse.json();
        if (!tokenResponse.ok) {
            const error = new Error(tokenInfo.message || "Failed to authenticate.");
            throw error;
        }

        const userResponse = await authServer.get('/me', {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + tokenInfo.access_token,
            },
        });
        if (!userResponse.status === 200) {
            const error = new Error(userResponse.message || "Failed to fetch user.");
            throw error;
        }
        const userInfo = await userResponse.data;
        const createUser = {
            sub: userInfo.sub,
            name: userInfo.name,
            email: userInfo.email,
            birthdate: userInfo.birthdate,
            family_name: userInfo.family_name,
            given_name: userInfo.given_name,
            middle_name: userInfo.middle_name,
            nickname: userInfo.nickname,
            preferred_username: userInfo.preferred_username,
            locale: userInfo.locale,
            zoneinfo: userInfo.zoneinfo,
            phone_number: userInfo.phone_number,
        };

        // const friendResponse = await friendServer.post('/api/users', createUser, {
        //     headers: {
        //         "Content-Type": "application/json",
        //         "Authorization": "Bearer " + tokenInfo.id_token,
        //     }
        // });
        const friendResponse = await feedServer.post('/user', createUser, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + tokenInfo.id_token,
            }
        });
        if (!friendResponse.status === 201) {
            const error = new Error(friendResponse.message || "Failed to create user.");
            throw error;
        }

        const expiresIn = +tokenInfo.expires_in * 1000;
        const expirationDate = new Date().getTime() + expiresIn;

        localStorage.setItem('userId', userInfo.sub);
        localStorage.setItem('name', userInfo.name);
        localStorage.setItem('token', tokenInfo.id_token);
        localStorage.setItem('tokenExpiration', expirationDate);

        context.commit("setUser", {
            userId: userInfo.sub,
            name: userInfo.name,
            token: tokenInfo.id_token,
        });
    },
    attemptLogin(context) {
        const userId = localStorage.getItem('userId');
        const name = localStorage.getItem('name');
        const token = localStorage.getItem('token');
        const tokenExpiration = localStorage.getItem('tokenExpiration');
        const expiresIn = +tokenExpiration - new Date().getTime();

        if (expiresIn < 0) {
            return;
        }
        timer = setTimeout(function () {
            context.dispatch('autoLogout');
        }, expiresIn);
        if (token && userId) {
            context.commit('setUser', {
                userId: userId,
                name: name,
                token: token,
            });
        }
    },
    async logout(context) {
        localStorage.removeItem('userId');
        localStorage.removeItem('token');
        localStorage.removeItem('tokenExpiration');

        clearTimeout(timer);

        context.commit('setUser', {
            userId: null,
            token: null,
            name: null,
        });
    },
    autoLogout(context) {
        context.dispatch('logout');
        context.commit('setAutoLogout');
    }
};